import { educationActions } from '../actionType';

export const educationReducer = (state, action) => {
    switch (action.type) {
        case educationActions.SAVE_TEACHER: {
            return {
                teacher: action.payload,
                msg: action.payload.length === 0 ? "No Data Found" : ""
            }
        }
        default:
            return state;
    }
}